import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const facultyStatisticsApi = createApi({
  reducerPath: 'facultyStatisticsApi',
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getFacultyStatistics: builder.query({
      query: () => ({
        url: urls.facultyStatistics,
        method: 'GET',
        // homepage counter only: no error page, toast or global fetching state
        silent: true,
      }),
      transformResponse: (response) => response?.data ?? {},
    }),
  }),
});

export const { useGetFacultyStatisticsQuery } = facultyStatisticsApi;
